import { Segment } from '@mairistem/composants';
import _ from 'lodash';
import React from 'react';
import { FactureContext } from '@/contexts';
import {
  CycleContextProvider,
  FactureContextProvider,
  LoadingContextProvider,
  ModeReglementContextProvider,
} from '../Context';
import FacturesListe from './FacturesListe';
import ModalFactureDetail from './ModalFactureDetail';

/**
 * Composant servant pour le point de menu "Factures"
 */
const FacturesMenu = () => {
  const [modalDetail, setModalDetail] = React.useState<number | null>();

  const handleFactureDetailShow = React.useCallback((id: number) => {
    setModalDetail(id);
  }, []);

  return (
    <Segment basic secondary style={{ margin: 0, height: '100%' }}>
      <Segment style={{ height: '100%', overflow: 'hidden' }} id="factures-recus">
        <LoadingContextProvider>
          <ModeReglementContextProvider autoload="régie">
            <CycleContextProvider allAtOnce>
              <FactureContextProvider type="all">
                <FactureContext.Consumer>
                  {({ factures }) => (
                    <>
                      <FacturesListe standAlone onEncaissement={handleFactureDetailShow} />
                      {modalDetail && (
                        <ModalFactureDetail
                          facture={_.find(factures, { identifiant: modalDetail })}
                          onClose={() => setModalDetail(null)}
                        />
                      )}
                    </>
                  )}
                </FactureContext.Consumer>
              </FactureContextProvider>
            </CycleContextProvider>
          </ModeReglementContextProvider>
        </LoadingContextProvider>
      </Segment>
    </Segment>
  );
};

export default FacturesMenu;
